import { Component, OnDestroy, OnInit } from '@angular/core'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { select, Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Component({
  selector: 'app-external-mobile-dashboard',
  templateUrl: './external-mobile-dashboard.component.html',
  styleUrls: ['./external-mobile-dashboard.component.css'],
})
export class ExternalMobileDashboardComponent implements OnInit, OnDestroy {
  public settings$: Subscription
  public settings: any
  public externalURL: SafeResourceUrl

  constructor(
    public store: Store<any>,
    public sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.settings = state.get('data').toJS()

        this.externalURL = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.settings?.externalDashboards?.SETTINGS_EXTERNAL_MOBILE_URL,
        )
      })
  }

  ngOnDestroy(): void {}
}
